import React, { Fragment } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import LoginLink from 'src/components/LoginLink';
import Button from 'src/components/Button';


export const TopNav = () => {
  const { isLoading, isAuthenticated, user } = useAuth0();
  
  return (
    <Fragment>
      {!user && <nav className="uk-navbar-container uk-flex-column uk-flex-top uk-padding-none uk-navbar-transparent" data-uk-navbar data-uk-toggle="media: @s; cls: uk-flex-row uk-flex-top; mode: media">
        <button data-uk-toggle="target: .navbar-collapse; cls: uk-visible@s uk-padding-remove"
          className="uk-navbar-toggle uk-padding uk-padding-remove-vertical uk-hidden@s" data-uk-navbar-toggle-icon></button>
        <div className="navbar-collapse uk-visible@s">
          <div className="uk-navbar-right" >
            &nbsp;
            <ul data-uk-toggle="media: @s; cls: uk-navbar-nav uk-padding-remove; mode: media" className="uk-nav uk-navbar-nav uk-padding-remove uk-navbar-dropdown-nav uk-text-uppercase">
               <li>
                <LoginLink>
                  <Button style='secondary' className="uk-button-small">
                    Login
                  </Button>
                </LoginLink>
              </li>
              <li>
                <LoginLink create={true}>
                  <Button style='primary' className="uk-button-small">
                    Create Account
                  </Button>
                </LoginLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      }

    </Fragment >
  );
};

